<qv-manufacturer-mapping-wrapper></qv-manufacturer-mapping-wrapper>
